/**
 * Shared span-excerpt truncation for CBE provenance surfaces.
 *
 * One canonical implementation (moved out of `contextFinancialFill.ts` when
 * the SED-send renderer became a second consumer) so the provenance chip
 * (`context:{tag} — "{excerpt}"`) and the prompt's `span:` line render the
 * same excerpt for the same span. Pure.
 */

/** Truncate a span to a chip-sized excerpt (collapses whitespace). */
export function spanExcerpt(span: string, max = 140): string {
  const s = span.trim().replace(/\s+/g, ' ');
  return s.length <= max ? s : `${s.slice(0, max - 1)}…`;
}
